module.exports = __webpack_public_path__ + "img/subject_banner16.fb6725bb.png";